<!-- <p>visitor-invite works!</p> -->
<!-- <div class="close-button">
  <button (click)="onClose()" mat-raised-button>
    {{ "Back" }}
  </button>
</div> -->
<div class="visitor-invite-container">
  <mat-card class="visitor-invite-card">
    <mat-card-header
      [ngClass]="{
        'visitor-invite-card-header':
          screenInfo == ScreenType.Desktop || screenInfo == ScreenType.Tablet,
        'visitor-invite-card-header-mobile': screenInfo == ScreenType.Mobile
      }"
      ><button mat-mini-fab (click)="onClose()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      New Guest Invite For
      {{ selectedDate | date : "EEEE, MMMM d, y, h:mm a" }}</mat-card-header
    >
    <!-- {{ selectedDate }}</mat-card-header -->
    <mat-card-content class="visitor-invite-card-content">
      <div class="row">
        <div class="col">
          <app-visitor-invite-form
            (onCreateNewVisitor)="createNewVisitor($event)"
            (onUpdateVisitor)="updateVisitor($event)"
            [hostLists]="hostLists"
            [visitorList]="visitorList"
            (onCancelVisitorInvite)="onClose()"
            [selectedDate]="selectedDate"
            [screen]="screenInfo"
          ></app-visitor-invite-form>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
